const contactsCompanyResources = {
  en: {
    contactsCompany: {
      title: 'Contacts',
      text1: 'HEAD OFFICE',
      text2:
        'ADDRESS: 187 B, N.Nazarbayev Ave., "STAR" Business Center, city of Almaty',
      text3: 'PHONE NUMBER: +7 (727) 356 25 25.',
      text4:
        'CALL CENTER: 3264, free of charge for calls from mobile phones throughout Kazakhstan.',
      text5: 'E-MAIL: info@acgarant.kz',
      text6: 'Branches in Almaty:',
      text7: 'Address: 189 Muratbayev str., Almaty, (branch)',
      text8: 'Opening hours: Mon-Fri 09:00-18:00, lunch break: 13:00-14:00',
      text9: 'Sales Department contacts 8 (727) 3562525',
      text10:
        'Contacts of the Insurance payments department: 3264 (from 9.00 to 18.00)',
      text11:
        'Head: Director of Branch No.2 on Muratbayev str., in Almaty tel. 8 (727) 3562525 ext. 2260',
      text12:
        'Deputy Director of the retail insurance branch tel. 8 (727) 3562525 ext. 2253',
      text13:
        'Deputy Director of the Corporate Insurance branch tel. 8 (727) 3562525 ext. 2256',
      text14:
        'Services: Motor transport, Property of individuals. persons, Travel, Medicine, Health, Cargo, Property of enterprises, Responsibility of enterprises, Financial risks',
      text15: 'Address: 18 A, Aksay microdistrict 5, Almaty, (branch)',
      text16: 'PHONE: 8 (727) 3562525',
      text17: 'Opening hours: Mon-Fri 09:00-18:00, lunch break: 13:00-14:00',
      text18: 'Sales Department contacts 8 (727) 3562525',
      text19:
        'Contacts of the Insurance payments department: 3264 (from 9.00 to 18.00)',
      text20:
        'Head: Branch Director: Ardabayeva Nazym Tleulesovna - 8 (727) 3562525 ext. 2201',
      text21:
        'Services: Motor transport, Property of individuals. persons, Travel, Medicine, Health, Cargo, Property of enterprises, Responsibility of enterprises, Financial risks',
    },
  },
  kz: {
    contactsCompany: {
      title: 'Байланыс',
      text1: 'БАС КЕҢСЕ',
      text2: 'МЕКЕНЖАЙЫ: Алматы қ., Н.Назарбаев даңғылы,187 Б, «STAR» БО',
      text3: 'ТЕЛЕФОНЫ: +7 (727) 356 25 25.',
      text4:
        'CALL CENTER: 3264, Қазақстан бойынша мобильді телефоннан қоңырау шалу тегін.',
      text5: 'E-MAIL: info@acgarant.kz',
      text6: 'Алматы қаласындағы филиалдар:',
      text7: 'Мекенжайы: Алматы, Мұратбаев көш., 189 (филиал)',
      text8: 'Жұмыс кестесі: Дс-Жм 09:00-18:00, түскі үзіліс: 13:00-14:00',
      text9: 'Сату бөлімінің байланыс телефоны: 8 (727) 3562525',
      text10:
        'Сақтандыру  төлемдері бөлімінің байланыстары: 3264 (9.00-дан 18.00-ге дейін)',
      text11:
        'Басшысы: Алматы қ. Мұратбаев көшесіндегі №2 филиалдың директоры, тел. 8 (727) 3562525 ішкі 2260',
      text12:
        'Бөлшек  сақтандыру филиалы директорының орынбасары, тел. 8 (727) 3562525 іш. 2253',
      text13:
        'Корпоративтік  сақтандыру филиалы директорының орынбасары, тел. 8 (727) 3562525 іш.2256',
      text14:
        'Көрсетілетін қызметтер: Автокөлік, Жеке тұлғалардың мүлкі, Саяхат, Медицина, Денсаулық, Жүктер, Кәсіпорындар мүлкі,  Кәсіпорындар жауапкершілігі, Қаржылық тәуекелдер',
      text15: 'Мекенжайы: Алматы, Аксай ықш. 5, 18А (филиал)',
      text16: 'ТЕЛЕФОНЫ: 8 (727) 3562525',
      text17: 'Жұмыс кестесі: Дс-Жм 09:00-18:00, түскі үзіліс: 13:00-14:00',
      text18: 'Сату бөлімінің байланыс телефоны 8 (727) 3562525',
      text19:
        'Сақтандыру төлемдері бөлімінің байланыстары: 3264 (9.00-дан 18.00-ге дейін)',
      text20:
        'Басшы: филиал директоры: Ардабаева Назым Тлеулесовна - 8 (727) 3562525 іш. 2201',
      text21:
        'Көрсетілетін қызметтер: Автокөлік, Жеке тұлғалардың мүлкі, Саяхат, Медицина, Денсаулық, Жүктер, Кәсіпорындар мүлкі, Кәсіпорындар жауапкершілігі, Қаржылық тәуекелдер',
    },
  },
  ru: {
    contactsCompany: {
      title: 'Контакты',
      text1: 'ГОЛОВНОЙ ОФИС',
      text2: 'АДРЕС: , г.Алматы, пр-т Н.Назарбаева 187 Б, БЦ «STAR»',
      text3: 'ТЕЛЕФОН: +7 (727) 356 25 25.',
      text4:
        'CALL CENTER: 3264, бесплатно для звонков с мобильных по всему Казахстану.',
      text5: 'E-MAIL: info@acgarant.kz',
      text6: 'Филиалы в Алматы:',
      text7: 'Адрес: Алматы, Муратбаева, 189 (филиал)',
      text8: 'График работы: Пн-Пт 09:00-18:00, перерыв на обед: 13:00-14:00',
      text9: 'Контакты отдела продаж 8 (727) 3562525',
      text10: 'Контакты отдела Страховых выплат: 3264 (с 9.00 до 18.00)',
      text11:
        'Руководитель: Директор Филиала №2 на Муратбаева по г.Алматы тел. 8 (727) 3562525 вн 2260',
      text12:
        'Зам директора филиала по розничному страхованию тел. 8 (727) 3562525 вн. 2253',
      text13:
        'Зам директора филиала по корпоративному страхованию тел. 8 (727) 3562525 вн. 2256',
      text14:
        'Услуги: Автотранспорт, Имущество физ. лиц, Путешествие, Медицина, Здоровье, Грузы, Имущество предприятий, Ответственность предприятий, Финансовые риски',
      text15: 'Адрес: Алматы, мкр. Аксай 5, 18А (филиал)',
      text16: 'ТЕЛЕФОН: 8 (727) 3562525',
      text17: 'График работы: Пн-Пт 09:00-18:00, перерыв на обед: 13:00-14:00',
      text18: 'Контакты отдела продаж 8 (727) 3562525',
      text19: 'Контакты отдела Страховых выплат: 3264 (с 9.00 до 18.00)',
      text20:
        'Руководитель: Директор филиала: Ардабаева Назым Тлеулесовна - 8 (727) 3562525 вн. 2201',
      text21:
        'Услуги: Автотранспорт, Имущество физ. лиц, Путешествие, Медицина, Здоровье, Грузы, Имущество предприятий, Ответственность предприятий, Финансовые риски',
    },
  },
};

export default contactsCompanyResources;
